import React, { useEffect, useState } from "react";
import { Form, Input, Modal, Col, Button, Descriptions } from "antd";
import {
  LeftOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  CheckOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
  WarningOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  getSingleInvoiceRequestData,
  editRoyaltyInvoiceRequestData,
  getPartnerInvoiceData,
} from "../../../appRedux/actions";
import { royalty_countries_product } from "../../../constants";
import moment from "moment";
import { getRole, getUserInfo, getIsApprover } from "../../../helpers";
import { useNavigate } from "react-router-dom";
const confirm = Modal.confirm;

const { TextArea } = Input;

const ViewInvoiceInvoiceTracking = (props) => {
  const navigate = useNavigate();
  const { editInvoiceRequestData } = useSelector(
    ({ partnerInvoice }) => partnerInvoice,
  );
  const [isAdminApprover, setIsAdminApprover] = useState([]);
  const [isUserAdmin, setIsUserAdmin] = useState(false);
  const [isUserPartner, setIsUserPartner] = useState(false);
  const [isUserLicensor, setIsUserLicensor] = useState(false);
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const fetchData = async () => {
    const { path, params } = props.match;
    await dispatch(getSingleInvoiceRequestData(params.id));
    setIsAdminApprover(getIsApprover());
    setIsUserAdmin(() => {
      return getRole() === "ADMIN";
    });
    setIsUserPartner(() => {
      return getRole() === "PARTNER";
    });
    setIsUserLicensor(() => {
      return getRole() === "LICENSOR";
    });
  };

  const navigateToAddPaymentData = (id) => {
    navigate(
      `/partner/partner-invoice/add-payment-proof/${editInvoiceRequestData.tracking_id}`,
    );
  };

  useEffect(() => {
    fetchData();
  }, []);

  const navigateBack = () => {
    navigate(-1);
  };

  let isDisabled =
    editInvoiceRequestData.licensor_status === "PENDING" ||
    editInvoiceRequestData.partner_status === "NEEDS REVISION";
  const isDisabledPaid = editInvoiceRequestData.licensor_status == "PAID";

  const showCommentsForm = () => {
    return (
      <Form form={form} layout="vertical" className="mt-20">
        <div className="mb-10">
          <span>Add comments:</span>
        </div>
        <Form.Item
          name="comment"
          className="mb-0"
          rules={[
            {
              required: isUserAdmin,
              message: isUserAdmin ? "Enter comments" : "Enter comments",
            },
          ]}
        >
          <TextArea placeholder="Enter comments here" />
        </Form.Item>
      </Form>
    );
  };

  const showApproveConfirm = (item, partner_id) => {
    confirm({
      title: "Do you want to submit the report?",
      className: "btn-confirm-green",
      content: showCommentsForm(),
      icon: <CheckCircleOutlined />,
      okText: "Submit",
      cancelText: "Cancel",
      onOk(close) {
        form.validateFields().then((values) => {
          const approveFormData = new FormData();
          approveFormData.append("licensor_status", "APPROVED");
          approveFormData.append("licensor_comment", values.comment);
          approveFormData.append("partner_id", parseInt(partner_id));
          dispatch(
            editRoyaltyInvoiceRequestData(
              item,
              approveFormData,
              () => {
                dispatch(getPartnerInvoiceData());
                navigateBack();
              },
              "Submitted",
            ),
          );
          close();
        });
      },
      onCancel() {
        form.resetFields(["comment"]);
      },
    });
  };

  const showRejectConfirm = (item, partner_id) => {
    confirm({
      title: "Do you want to request for revision?",
      className: "btn-confirm-red",
      content: showCommentsForm(),
      okText: "Needs Revision",
      cancelText: "Cancel",
      icon: <CloseCircleOutlined />,
      onOk(close) {
        form.validateFields().then((values) => {
          const rejectFormData = new FormData();
          rejectFormData.append("licensor_status", "REJECTED");
          rejectFormData.append("licensor_comment", values.comment);
          rejectFormData.append("partner_id", parseInt(partner_id));
          dispatch(
            editRoyaltyInvoiceRequestData(
              item,
              rejectFormData,
              () => {
                dispatch(getPartnerInvoiceData());
                navigateBack();
              },
              "Needs Revision",
            ),
          );
          close();
        });
      },
      onCancel() {
        form.resetFields(["comment"]);
      },
    });
  };
  const showPaidConfirm = (item, partner_id) => {
    confirm({
      title: "Do you want to mark this request as paid?",
      className: "btn-confirm-primary",
      content: showCommentsForm(),
      okText: "Submit",
      cancelText: "Cancel",
      icon: <ExclamationCircleOutlined />,
      onOk(close) {
        form.validateFields().then((values) => {
          const rejectFormData = new FormData();
          rejectFormData.append("licensor_status", "PAID");
          rejectFormData.append("partner_status", "PAID");
          rejectFormData.append("partner_comment", values.comment);
          rejectFormData.append("licensor_comment", values.comment);
          rejectFormData.append("partner_id", parseInt(partner_id));
          dispatch(
            editRoyaltyInvoiceRequestData(
              item,
              rejectFormData,
              () => {
                dispatch(getPartnerInvoiceData());
                navigateBack();
              },
              "Status Sent",
            ),
          );
          close();
        });
      },
      onCancel() {
        form.resetFields(["comment"]);
      },
    });
  };
  const showInvalidConfirm = (item, partner_id) => {
    confirm({
      title: "Do you want to mark this request as invalid?",
      className: "btn-confirm-primary",
      content: showCommentsForm(),
      okText: "Submit",
      cancelText: "Cancel",
      icon: <WarningOutlined />,
      onOk(close) {
        form.validateFields().then((values) => {
          const rejectFormData = new FormData();
          rejectFormData.append("partner_status", "INVALID");
          rejectFormData.append("partner_comment", values.comment);
          rejectFormData.append("partner_id", parseInt(partner_id));
          rejectFormData.append("is_approved", false);
          dispatch(
            editRoyaltyInvoiceRequestData(
              item,
              rejectFormData,
              () => {
                dispatch(getPartnerInvoiceData());
                navigateBack();
              },
              "Status Sent",
            ),
          );
          close();
        });
      },
      onCancel() {
        form.resetFields(["comment"]);
      },
    });
  };

  const showNeedRevisionConfirm = (item, partner_id) => {
    confirm({
      title: "Do you want to request for revision?",
      className: "btn-confirm-primary",
      content: showCommentsForm(),
      okText: "Submit",
      cancelText: "Cancel",
      icon: <WarningOutlined />,
      onOk(close) {
        form.validateFields().then((values) => {
          const rejectFormData = new FormData();
          rejectFormData.append("partner_status", "NEEDS REVISION");
          rejectFormData.append("partner_comment", values.comment);
          rejectFormData.append("partner_id", parseInt(partner_id));
          dispatch(
            editRoyaltyInvoiceRequestData(
              item,
              rejectFormData,
              () => {
                dispatch(getPartnerInvoiceData());
                navigateBack();
              },
              "Needs Revision",
            ),
          );
          close();
        });
      },
      onCancel() {
        form.resetFields(["comment"]);
      },
    });
  };
  const labelStyle = { width: "200px" };

  return (
    <div>
      <Col span={24}>
        <div
          className="gx-flex-row"
          style={{ justifyContent: "space-between" }}
        >
          <h1 className="title gx-mb-4">
            <LeftOutlined className="mr-5" onClick={navigateBack} />
            Partner Invoice Information
          </h1>
          {isUserAdmin && isDisabled && (
            <div>
              <Button
                className="gx-btn-success"
                icon={<CheckOutlined />}
                onClick={() =>
                  showApproveConfirm(
                    editInvoiceRequestData.tracking_id,
                    editInvoiceRequestData.partner_id.partner_id,
                  )
                }
                id={`approve-${editInvoiceRequestData.tracking_id}`}
                disabled={!isDisabled}
              >
                Submit
              </Button>

              <Button
                className="gx-btn-danger"
                icon={<CloseOutlined />}
                onClick={() =>
                  showRejectConfirm(
                    editInvoiceRequestData.tracking_id,
                    editInvoiceRequestData.partner_id.partner_id,
                  )
                }
                id={`reject-${editInvoiceRequestData.tracking_id}`}
                disabled={!isDisabled}
              >
                Needs Revision
              </Button>
            </div>
          )}
          {isUserAdmin &&
            editInvoiceRequestData.partner_status == "PAID" &&
            editInvoiceRequestData.licensor_status !== "PAID" && (
              <div>
                <Button
                  className="gx-btn-success"
                  icon={<CheckOutlined />}
                  onClick={() =>
                    showPaidConfirm(
                      editInvoiceRequestData.tracking_id,
                      editInvoiceRequestData.partner_id.partner_id,
                    )
                  }
                  id={`paid-${editInvoiceRequestData.tracking_id}`}
                  disabled={isDisabledPaid}
                >
                  Paid
                </Button>

                <Button
                  className="gx-btn-danger"
                  icon={<CloseOutlined />}
                  onClick={() =>
                    showInvalidConfirm(
                      editInvoiceRequestData.tracking_id,
                      editInvoiceRequestData.partner_id.partner_id,
                    )
                  }
                  id={`invalid-${editInvoiceRequestData.tracking_id}`}
                  disabled={isDisabledPaid}
                >
                  Invalid
                </Button>
              </div>
            )}

          {isUserPartner &&
            editInvoiceRequestData.partner_status == "UNDER PROCESS" && (
              <div>
                <Button
                  type="primary"
                  id="raise-request"
                  onClick={navigateToAddPaymentData}
                >
                  <UploadOutlined />
                  Add Payment Proof
                </Button>

                <Button
                  className="gx-btn-danger"
                  icon={<CloseOutlined />}
                  onClick={() =>
                    showNeedRevisionConfirm(
                      editInvoiceRequestData.tracking_id,
                      editInvoiceRequestData.partner_id.partner_id,
                    )
                  }
                  id={`reject-${editInvoiceRequestData.tracking_id}`}
                >
                  Needs Revision
                </Button>
              </div>
            )}
          {isUserPartner &&
            editInvoiceRequestData.partner_status == "INVALID" && (
              <div>
                <Button
                  type="primary"
                  id="raise-request"
                  onClick={navigateToAddPaymentData}
                >
                  <UploadOutlined />
                  Edit Payment Proof
                </Button>
              </div>
            )}
        </div>
      </Col>
      <Col span={12}>
        <Descriptions bordered column={1}>
          <Descriptions.Item label="Company Name" style={labelStyle}>
            {editInvoiceRequestData?.partner_id?.company_name}
          </Descriptions.Item>
          <Descriptions.Item label="Issue Date" style={labelStyle}>
            {moment(editInvoiceRequestData.issue_date).format("DD/MM/YYYY")}
          </Descriptions.Item>
          <Descriptions.Item label="Invoice Due Date" style={labelStyle}>
            {moment(editInvoiceRequestData.invoice_due_date).format(
              "DD/MM/YYYY",
            )}
          </Descriptions.Item>
          {editInvoiceRequestData?.payment_date && (
            <Descriptions.Item label="Payment_date" style={labelStyle}>
              {moment(editInvoiceRequestData?.payment_date).format(
                "DD/MM/YYYY",
              )}
            </Descriptions.Item>
          )}
          <Descriptions.Item label="Amount" style={labelStyle}>
            {editInvoiceRequestData.amount}
          </Descriptions.Item>
          <Descriptions.Item label="Quarter" style={labelStyle}>
            {editInvoiceRequestData.quarter}
          </Descriptions.Item>
          <Descriptions.Item label="Status" style={labelStyle}>
            {isUserPartner ? (
              <span
                style={{
                  color:
                    editInvoiceRequestData.partner_status === "PAID" ||
                    editInvoiceRequestData.partner_status === "APPROVED"
                      ? "green"
                      : editInvoiceRequestData.partner_status === "INVALID" ||
                          editInvoiceRequestData.partner_status === "REJECTED"
                        ? "red"
                        : "black",
                }}
              >
                {editInvoiceRequestData.partner_status}
              </span>
            ) : (
              <span
                style={{
                  color:
                    editInvoiceRequestData.licensor_status === "PAID" ||
                    editInvoiceRequestData.licensor_status === "APPROVED"
                      ? "green"
                      : editInvoiceRequestData.licensor_status === "INVALID" ||
                          editInvoiceRequestData.licensor_status === "REJECTED"
                        ? "red"
                        : "black",
                }}
              >
                {editInvoiceRequestData.licensor_status}
              </span>
            )}
          </Descriptions.Item>
          {editInvoiceRequestData?.licensor_comment && (
            <Descriptions.Item label="Comments" style={labelStyle}>
              {editInvoiceRequestData.licensor_comment}
            </Descriptions.Item>
          )}

          <Descriptions.Item label="Invoice" style={labelStyle}>
            {editInvoiceRequestData?.invoice_file?.map((file, index) => (
              <>
                <a
                  key={file.id}
                  href={file.document}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  INVOICE {index + 1}
                </a>
                <br />
              </>
            ))}
          </Descriptions.Item>

          <Descriptions.Item label="Payment Proof" style={labelStyle}>
            {editInvoiceRequestData?.payment_file?.map((file, index) => (
              <>
                <a
                  key={file.id}
                  href={file.document}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  PAYMENT PROOF {index + 1}
                </a>
                <br />
              </>
            ))}
          </Descriptions.Item>
          {/* Add more descriptions for other fields */}
        </Descriptions>
      </Col>
    </div>
  );
};

export default ViewInvoiceInvoiceTracking;